import {Component, EventEmitter, Input, OnInit, ViewChild} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {WarningModalService} from "../../../../services/warning-modal/warning-modal.service";
import {AbstractModalComponent} from "../../../abstract-modal/abstract-modal.component";

@Component({
  selector: 'app-select-questionnaire-modal',
  templateUrl: './select-questionnaire-modal.component.pug',
  styleUrls: ['./select-questionnaire-modal.component.scss'],
  standalone: false
})
export class SelectQuestionnaireModalComponent extends AbstractModalComponent implements OnInit {
  public nextClick: EventEmitter<any> = new EventEmitter();
  @ViewChild('requestForm', {static: false}) requestForm: any;
  @Input() questionnaireList: any;
  @Input() surveyType: any;
  questionnaire!: any;

  constructor(public _bsModalRef: BsModalRef,
              public modal: WarningModalService) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
  }

  cancel() {
    this._bsModalRef.hide();
  }

  selectedQuestionnaire(data: any) {
    this.questionnaire = data;
  }

  selectQuestionnaire() {
    this.nextClick.emit({questionnaire: this.questionnaire, surveyType: this.surveyType})
    this._bsModalRef.hide();
  }

  getForm() {
    return this.requestForm;
  }

}
